export default __webpack_public_path__ + "static/media/bitmoji_beststudent.427af6ca.png";